import Service from "../../../Services/index";

const RateSalaryHistory = {
    namespaced: true,
    state: {
        salaryHistoryList: [],
        search: {
            employee_type: "",
            department: "",
            departments: "",
            employee: '',
            date: "",
            active: '',
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        GET_SALARY_HISTORY: (state, res) => {
            state.salaryHistoryList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                employee_type: "",
                department: "",
                employee: '',
                date: "",
                active: ''
            }
        }
    },
    actions: {
        setRateSalaryHistory({commit}, page = 1) {
            return Service.RateSalaryHistory.getRateSalaryHistory(page).then(response => {
                commit("GET_SALARY_HISTORY", response);
            });
        },
        search({commit}, data) {
            //console.log(data);
            return Service.RateSalaryHistory.searchRateSalaryHistory(data).then(res => {
                commit("GET_SALARY_HISTORY", res)
            })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        }
    }
};
export default RateSalaryHistory;
